import { baseUrl } from "../../../../boot";
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

// Add Category API
export const addCategory = createAsyncThunk(
  "category/add",
  async (formData, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    
    try {
      const response = await axios.post(
        `${baseUrl}category/api/v1/addCategory`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to add category");
    }
  }
);

// Update Category API
export const updateCategory = createAsyncThunk(
  "category/update",
  async ({ id, data }, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    
    try {
      const response = await axios.put(
        `${baseUrl}category/api/v1/updateCategory/${id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update category");
    }
  }
);

// Delete Category API
export const deleteCategory = async (ROWID) => {
  console.log("ROWID", ROWID);
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.delete(
      `${baseUrl}category/api/v1/deleteCategory`,
      {
        headers: {
          "auth-token": token,
        },
        data: { ids: [ROWID] }, // 👈 correct place
      }
    );

    return response;
  } catch (error) {
    console.error("Error:", error.response || error.message || error);
    throw error;
  }
};
// Get Categories API
export const getCategories = createAsyncThunk(
  "category/get",
  async (params, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    const { page = 1, limit = 10, search = {} } = params || {};
    
    try {
      const response = await axios.post(
        `${baseUrl}category/api/v1/getCategories`,
        { page, limit, search },
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch categories");
    }
  }
);

export const getCategoryDetailById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}category/api/v1/getCategory/${id}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}


// total count
export const countCategory = async (formData) => {
  console.log(formData,"count")
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}crm/api/v1/get-deals-count`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}